<template>
    <div class="link link--whiteboard" @click="getWhiteboardLink">
        <span class="link-whiteboard__image">
           <img :src="env.public_base + '/assets/images/file-icon.svg'" alt="">
        </span>
        <span>{{ $t('go_to_whiteboard') }}</span>
    </div>
</template>

<script>
    import env from '../../env';
    import { mapGetters } from 'vuex'
    export default {
        props: ['id'],
        data: () => ({
            env
        }),
        computed: {
            ...mapGetters(['channelId']),
        },
        methods: {
            getWhiteboardLink() {
                this.$store.dispatch('getWhiteboardLink', this.id);
            }
        }
    }
</script>
